import { Dropdown } from 'src/design-system'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import Select from 'react-select'
import * as Components from './components'
import { TriggerContent } from './components/trigger'
import { ProfileSkillSelectVm } from './profile-skill-select-vm'
import {
  ProfileSkillSelectProps,
  TProfileSkillOption,
} from './profile-skill-select.types'

export const ProfileSkillSelect = observer((props: ProfileSkillSelectProps) => {
  const {
    defaultProfileSkillIds,
    menuIsOpen,
    name = 'profile_skills',
    profileSkills,
    noOptionsMessage = 'No personal skills found',
    triggerContent,
    onChange,
  } = props

  const vm = React.useMemo(() => {
    return new ProfileSkillSelectVm(profileSkills, defaultProfileSkillIds)
  }, [profileSkills, defaultProfileSkillIds])

  const [value, setValue] = React.useState<
    readonly TProfileSkillOption[] | null
  >(vm.defaultValue)

  const [inputValue, setInputValue] = React.useState('')
  const [open, setOpen] = React.useState(!!menuIsOpen)

  return (
    <Dropdown.Root open={open} onOpenChange={setOpen}>
      <TriggerContent {...{ name, value, triggerContent }} />
      <Dropdown.Content align="start" forceMount={menuIsOpen || undefined}>
        <Select
          autoFocus
          defaultValue={vm.defaultValue}
          backspaceRemovesValue={false}
          components={Components}
          controlShouldRenderValue={false}
          hideSelectedOptions={false}
          isClearable
          blurInputOnSelect={false}
          onChange={(value) => {
            setValue(value)
            onChange?.(value.map((v) => v.value))
          }}
          value={value}
          menuIsOpen
          isMulti
          options={vm.options}
          noOptionsMessage={() => noOptionsMessage}
          placeholder="Add personal skills..."
          inputValue={inputValue}
          onInputChange={(value, action) => {
            if (action.action === 'input-change') setInputValue(value)
          }}
          onKeyDown={(event) => {
            if (event.key === 'Escape') setOpen(false)
          }}
          styles={{
            menu: () => ({}),
            groupHeading: () => ({}),
          }}
        />
      </Dropdown.Content>
    </Dropdown.Root>
  )
})
